<template>
  <v-row align="center" justify="center">
    <v-col class="pa-0">
      <v-card class="toggleContent" flat color="transparent">
        <component
          id="mainComponent"
          v-bind:is="component"
          @switchComponent="switchComponent"
          :propsData="productComponentProps"
          @addToCart="addToShoppingCart"
          :scrollToSection="true"
        ></component>
        <div class="text-xs-center">
          <v-dialog v-model="shoppingCartInfoDialog" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{ $translate('ATTENTION') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-4">
                {{ shoppingInfoDialogText }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="shoppingCartInfoDialog = false"
                >
                  {{ $translate('CLOSE') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="forAgeAbove17" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                {{ $translate('WARNING') }}
              </v-card-title>
              <v-card-text>
                {{ $translate('EVENT_FORAGE_MESSAGE') }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" rounded @click="forAgeAbove17 = false">
                  {{ $translate('CLOSE') }}
                </v-btn>
                <v-btn
                  color="primary"
                  class="primary-font-color"
                  rounded
                  @click="checkTickets(forAgeAbove17Product, true)"
                >
                  {{ $translate('ACCEPT') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="weightedProductAlreadyInCartDialog"
            persistent
            max-width="500"
          >
            <v-card>
              <v-card-title class="headline">
                {{ $translate('ATTENTION') }}
              </v-card-title>
              <v-card-text>{{
                $translate('OVERWRITE_SHOPPING_CART_ITEM')
              }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="secondary"
                  text
                  @click="weightedProductAlreadyInCartDialog = false"
                >
                  {{ $translate('CANCEL') }}
                </v-btn>
                <v-btn
                  color="primary"
                  class="primary-font-color"
                  text
                  @click="overwriteProductInShoppingCart"
                >
                  {{ $translate('ADD_TO_SHOPPING_CART') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import uiHelpers from '@/shared/ui_helpers';
import doRequest from '@/api/dssRequest';
import ProductOrder from '@/components/event/eventDetails/productOrderComponents/ProductOrder';
import EventInstantProductDetails from '@/components/event/eventDetails/EventInstantProductDetails';
import EventDetailsProduct_Categories from './EventDetailsProduct_Categories.vue';
import EventDetailsProduct_ProductList from './EventDetailsProduct_ProductList.vue';

export default {
  name: 'EventDetailsProducts',
  mixins: [uiHelpers],
  components: {
    ProductOrder,
    EventDetailsProduct_Categories,
    EventDetailsProduct_ProductList,
    EventInstantProductDetails,
  },
  props: {
    btnSize: Object,
    eventDetails: Object,
  },
  data() {
    return {
      shoppingInfoDialogText: '',
      shoppingCartInfoDialog: false,
      weightedProductAlreadyInCartDialog: false,
      tab: 'tab-2',
      forAgeAbove17Product: {},
      forAgeAbove17: false,
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
      shoppingCart: {
        products: [],
        specialRequests: [],
      },
      productComponentProps: {
        eventId: '',
        eventType: '',
        categories: [],
        selectedCategory: {},
        selectedProduct: {},
        productsWithoutCategory: [],
      },
      component: '',
    };
  },
  computed: {
    ...mapGetters({
      userId: 'auth/userName',
    }),
  },
  watch: {
    userId(newV, oldV) {
      if (newV !== oldV) {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
  updated() {},
  methods: {
    init() {
      if (this.$route.params.product_id) {
        console.log('Brian 1 DO WE GET HERE ?!?!');
      } else if (
        this.$route.params.category_id &&
        !Object.keys(this.$store.getters['event/currentWatchedProduct']).length
      ) {
        // to find the full category details in eventDetails
        const self = this;
        const category = this.eventDetails.ProductCategories.filter(
          (innerCategory) =>
            innerCategory.Id === Number(self.$route.params.category_id)
        );

        this.component = 'EventDetailsProduct_ProductList';

        this.switchComponent({
          component: 'EventDetailsProduct_ProductList',
          eventId: this.$store.getters['event/currentEventId'],
          selectedCategory: category[0],
        });
      } else if (
        Object.keys(this.$store.getters['event/currentWatchedProduct']).length
      ) {
        // to find the full category details in eventDetails
        const self = this;
        const category = this.eventDetails.ProductCategories.filter(
          (innerCategory) =>
            innerCategory.Id === Number(self.$route.params.category_id)
        );

        this.component = 'EventDetailsProduct_ProductList';

        this.switchComponent({
          component: 'EventDetailsProduct_ProductList',
          eventId: this.$store.getters['event/currentEventId'],
          selectedCategory: category[0],
        });
      } else if (this.$store.getters['event/currentProductId'] !== '') {
        this.switchComponent({
          component: 'EventInstantProductDetails',
          eventId: this.$store.getters['event/currentEventId'],
          selectedProduct: {
            Id: this.$store.getters['event/currentProductId'],
          },
        });
      }
      if (!this.$route.params.category_id) {
        if (this.eventDetails.ProductCategories.length === 0) {
          this.getProductsWithoutCategory();
        } else {
          this.productComponentProps.categories =
            this.eventDetails.ProductCategories;
          this.component = 'EventDetailsProduct_Categories';
        }
      }
    },
    switchComponent(args) {
      // Trigger to switch component for products
      this.component = args.component;
      this.productComponentProps = {
        eventId: this.eventDetails.EventId,
        eventType: this.eventDetails.Type,
        categories: this.eventDetails.ProductCategories,
        productList: this.eventDetails.productList,
        selectedCategory:
          args.selectedCategory != null ? args.selectedCategory : {},
        selectedProduct:
          args.selectedProduct != null ? args.selectedProduct : {},
        productsWithoutCategory:
          args.productsWithoutCategory != null
            ? args.productsWithoutCategory
            : [],
      };
    },
    addToShoppingCart(product) {
      let stop = false;
      this.$store.getters['shoppingCart/orders'].forEach((productInCart) => {
        if (
          productInCart.Id === product.Id &&
          productInCart.ItemId === product.ItemId
        ) {
          if (product.Type === 'Standard') {
            productInCart.Quantity += product.Quantity;
          } else {
            // TODO make sure that type of weighted is handled if product is already in cart
            this.weightedProductAlreadyInCartDialog = true;
          }
          stop = true;
        }
      });
      if (!stop) {
        this.$emit('addToCart', product);
        window.EventBus.fire('reserve', product);
      }
    },
    overwriteProductInShoppingCart() {
      // TODO change function to new style
      this.$store.getters['shoppingCart/orders'].forEach(
        (productInCart, productInCartIndex) => {
          if (
            productInCart.Id ===
              this.productComponentProps.selectedProduct.Id &&
            productInCart.ItemId ===
              this.productComponentProps.selectedProduct.ItemId
          ) {
            this.$store.getters['shoppingCart/orders'].splice(
              productInCartIndex,
              1
            );
            this.$store.getters['shoppingCart/orders'].push(
              this.productComponentProps.selectedProduct
            );
          }
        }
      );
      this.weightedProductAlreadyInCartDialog = false;
      window.EventBus.fire(
        'activateSnackBar',
        this.$translate('PRODUCT_OVERWRITED_ITEM_IN_SHOPPING_CART')
      );
    },
    getProductsWithoutCategory() {
      const payload = {};
      doRequest(
        (response) => {
          delete response.data.ErrorMsg;
          const products = Object.keys(response.data.Products).map(
            (key) => response.data.Products[key]
          );
          this.productComponentProps.productsWithoutCategory = products;
          this.component = 'EventDetailsProduct_ProductList';
        },
        () => {},
        'getProductsV2',
        this.eventDetails.EventId,
        payload
      );
    },
  },
};
</script>

<style scoped lang="scss">
.productStyling {
  padding-right: 1em;
  box-shadow: 0px 1px 2px rgb(100, 100, 100) !important;
  margin: 0.5em 0 !important;
}
.productPrice {
  font-size: 1em;
}
.buttonGroup {
  padding-top: 1em;
}
.plusOrMinusButton {
  height: 30px !important;
  width: 30px !important;
}
.categoryCards {
  cursor: pointer;
  transition: opacity 0.4s ease-in-out;
}
.categoryCards:not(.on-hover) {
  opacity: 0.9;
}
</style>
